import React from 'react';
/**
 * Category description block for Daedo PSS Systems.
 *
 * Wrapped in `.category-description` / `wf-category-description` so
 * WebsiteForge can dynamically populate this region at import time.
 */
export function Description() {
  return <div className="category-description wf-category-description mb-12 max-w-4xl" data-id="element-200">
      <div className="prose prose-gray text-gray-700 text-base sm:text-lg leading-relaxed" data-id="element-201">
        Complete electronic scoring systems from Daedo, including receivers,
        transmitters, judge boxes, and W.T.-approved software. Build a full Gen
        2 or Gen 3 setup for your school, tournament, or training center.
      </div>
    </div>;
}